module.exports = "span h5 a:hover, span h4 a:hover{\n    color: #9e9e9e;\n}\n\n\n\n.col.s12.m3.fade-in-half-sec {\n    padding-bottom: 10px;\n}\n\n\n\n/** CARD W/ PLAY BUTTON **/\n\n\n\n.card-content {\n    color: rgb(236, 236, 236);\n    padding-bottom: 0;\n}\n\n\n\n.card-content:hover, .card-content-emulated-hover {\n    color: white;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/content/library/artists/artists.component.css
// module id = ./src/app/components/dashboard/content/library/artists/artists.component.css
// module chunks = main